import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import Constants from '../../../definitions/constants';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import LocaleTooling from '../../../tooling/localeTooling';

import GlassPopup from '../common/interface/glassPopup';
import ErrorFeedback from '../common/feedback/errorFeedback';
import Select from '../common/inputs/select';
import FieldInfo from '../common/inputs/fieldInfo';
import ExportBiReportsMultiModelSelector from './exportBiReportsMultiModelSelector';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';

const ExportBiReportsFormPopup = props => {
  const {
    handleShowPopup,
    handleButton,
    loadingButton,
    fullLoading,
    statusButton,
    formData,
    errors,
    popupState,
    modelsData,
    biTemplatesData,
    handleOnChangeFormData
  } = props;
  return (
    <GlassPopup
      className="form_popup import_form_popup"
      title={(<FormattedMessage id="periodAdmin.exportBiReportsPopup.title"/>)}
      buttonText={(<FormattedMessage id="periodAdmin.exportBiReportsPopup.button"/>)}
      {...props}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
        optionalStatusErrors={{
          "400": intl.formatMessage({id: "periodAdmin.exportBiReportsPopup.incompleteFormError"})
        }}
      />
      <p className="form_paragraph">
        {LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="periodAdmin.exportBiReportsPopup.intro"/>)}
      </p>
      <p className="form_paragraph">
        <FormattedMessage id="periodAdmin.exportBiReportsPopup.formatHelp"/>
      </p>
      <ExportBiReportsMultiModelSelector        
        values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"models_list")}
        onChange={handleOnChangeFormData}
        data-path="models_list"
        addSelectLocale={<FormattedMessage id="periodAdmin.exportBiReportsPopup.modelsSelectTitle"/>}
        labelLocale={<FormattedMessage id="periodAdmin.exportBiReportsPopup.modelsSelectTitle"/>}
        noMoreOptionsLocale={<FormattedMessage id="periodAdmin.exportBiReportsPopup.noMoreModelsSelectLocale"/>}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(modelsData, "id", "name")}
        biTemplatesData={biTemplatesData}
        valueAccesor={"model_id"}
        labelAccesor={"name"}
      /> 
    </GlassPopup>
  );
};

export default ExportBiReportsFormPopup;



// WEBPACK FOOTER //
// ./source/client/components/periodAdmin/exportBiReportsFormPopup.jsx